var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full_layout message", attrs: { id: "message" } },
    [
      !_vm.isNull
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "message_list_title message_list" },
                [
                  _c("el-checkbox", {
                    staticClass: "message_checkbox",
                    attrs: { isIndeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "message_products" }, [
                    _vm._v("标题")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message_detail" }, [
                    _vm._v("时间")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message_price" }, [_vm._v("消息")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message_number" }, [
                    _vm._v("状态")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message_total" }, [_vm._v("操作")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.handleCheckedCitiesChange },
                  model: {
                    value: _vm.checkedCities,
                    callback: function($$v) {
                      _vm.checkedCities = $$v
                    },
                    expression: "checkedCities"
                  }
                },
                _vm._l(3, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "message_list",
                      class: index == 0 ? "on" : ""
                    },
                    [
                      _c("el-checkbox", {
                        staticClass: "message_checkbox",
                        attrs: { label: item }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "message_checkbox_detail" }, [
                        _c("div", { staticClass: "message_products" }, [
                          _vm._v("物品已发货\n          ")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message_detail" }, [
                          _vm._v("2022-10-09 19:09:14\n          ")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message_price" }, [
                          _c("p", { staticClass: "line_txt3" }, [
                            _vm._v(
                              "第一款 2021 年 22 帕尼尼 DONRUSS OPTIC NBA 集换式卡盒2021 年 22 帕ONRUSS OPTIC NBA 集换式卡盒"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message_number" }, [
                          _vm._v("未读\n          ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "message_total" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { path: "/message/item/1" } } },
                              [_vm._v("查看详情")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("pagination", {
                attrs: { TotalCount: _vm.TotalCount, ps: _vm.ps },
                on: { ps: _vm.pageSize, pi: _vm.pageIndex }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNull
        ? _c("nonull", { attrs: { type: "message", text: "您还没有任何消息" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cartTitle" }, [
      _c("h3", [_vm._v("我的消息"), _c("span", [_vm._v("共3条消息")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-716a8bf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716a8bf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/message/index.vue
// module id = null
// module chunks = 